import { modalModes } from '../hooks/useBulkOnHold/constants'

export const titleByMode = {
  [modalModes.approve]: 'Aprobar solicitudes',
  [modalModes.decline]: 'Rechazar solicitudes',
}

export const acceptTextByMode = {
  [modalModes.approve]: 'Aprobar solicitudes',
  [modalModes.decline]: 'Rechazar solicitudes',
}
